import { EphemeralChatSurface } from '../../core/types/chat.types'
import { resolveEphemeralSurface } from './ephemeral-surface-registry'

type EphemeralSurfaceHostProps = {
  surface?: EphemeralChatSurface
  onSubmitSurface: (surface: EphemeralChatSurface) => void
  onAttachFiles: (files: FileList | File[]) => void
}

const EphemeralSurfaceHost = ({ surface, onSubmitSurface, onAttachFiles }: EphemeralSurfaceHostProps) => {
  if (!surface) return null

  const SurfaceComponent = resolveEphemeralSurface(surface.kind)
  if (!SurfaceComponent) return null

  return (
    <SurfaceComponent
      surface={surface}
      onSubmit={onSubmitSurface}
      onAttachFiles={onAttachFiles}
    />
  )
}

export default EphemeralSurfaceHost
